import React from 'react';

export default function DocumentTemplatesTab() {
  return (
    <div style={{
      padding: '32px 24px',
      background: '#fffde7',
      border: '1px solid #f9a825',
      borderRadius: 4,
      maxWidth: 560,
    }}>
      <h3 style={{ marginTop: 0, color: '#f57f17' }}>Document Templates</h3>
      <p style={{ margin: 0, color: '#555' }}>
        The document templates service endpoint is not yet configured.
        This tab will be enabled once the service URL and schema are confirmed.
      </p>
    </div>
  );
}
